import { forwardRef } from 'react';

import { TextInput, TextInputProps } from '@any-ui-react/core';
import classNames from 'classnames';
import { Popover } from 'radix-ui';

import { ChevronDownIcon, ClearIcon } from '@anyx/shared-icons';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxInputTriggerProps extends Omit<TextInputProps, 'rightSection'> {
  clearable?: boolean;
  onClear?: () => void;
}

export const ComboboxInputTrigger = forwardRef<HTMLInputElement, ComboboxInputTriggerProps>(
  ({ clearable, onClear, value, className, onChange, onFocus, onClick, onBlur, ...rest }, ref) => {
    const { store, classNames: contextClassNames, disabled, invalid } = useComboboxContext();
    const styles = comboboxStyles();

    const rightSection =
      clearable && value ? (
        <button
          type="button"
          className="flex items-center justify-center"
          onClick={(e) => {
            e.stopPropagation();
            onClear?.();
          }}
          onMouseDown={(e) => e.preventDefault()}
          tabIndex={-1}
          aria-label="Clear"
        >
          <ClearIcon className="fill-gray-5 h-3.5 w-3.5 cursor-pointer" />
        </button>
      ) : (
        <ChevronDownIcon className="text-gray-5 h-4 w-4" />
      );

    return (
      <Popover.Anchor asChild>
        <TextInput
          {...rest}
          ref={ref}
          value={value}
          disabled={disabled}
          error={invalid}
          className={classNames(styles.inputTrigger(), contextClassNames?.inputTrigger, className)}
          rightSection={rightSection}
          rightSectionPointerEvents={clearable && value ? 'all' : 'none'}
          onChange={(e) => {
            onChange?.(e);
            store?.openDropdown();
          }}
          onClick={(e) => {
            store?.openDropdown();
            onClick?.(e);
          }}
          onFocus={(e) => {
            store?.openDropdown();
            onFocus?.(e);
          }}
          onBlur={(e) => {
            store?.closeDropdown();
            onBlur?.(e);
          }}
        />
      </Popover.Anchor>
    );
  }
);
